"use strict";

exports.__esModule = true;
exports["default"] = exports.NextButton = exports.Next = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _slider = _interopRequireDefault(require("../../components/slider"));

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["isActive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NextButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "diagram-slider__NextButton",
  componentId: "sc-f9wq63-0"
})(["cursor:pointer;", " position:absolute;right:0;top:50%;transform:translateY(-50%);border-radius:5px 0 0 5px;fill:", ";box-shadow:0 4px 16px 0 ", ";"], function (props) {
  return props.disabled ? "display: none;" : "";
}, function (props) {
  return (0, _styles.colors)("icon-input", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.8, "background-dark")(props);
});
exports.NextButton = NextButton;
var propTypesButton = {
  /** Boolean prevents onClick */
  disabled: _propTypes.bool,

  /** onClick handler */
  onClick: _propTypes.func
};

var Next = function Next(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(NextButton, {
    backgroundColor: "background",
    disabled: disabled,
    height: 80,
    onClick: onClick,
    width: 50
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "span",
    display: "block",
    height: 32,
    width: 32
  }, /*#__PURE__*/_react["default"].createElement(_components.NavCaretRight, null))));
};

exports.Next = Next;
Next.propTypes = propTypesButton;
var PrevButton = (0, _styledComponents["default"])(_primitives["default"].Button).withConfig({
  displayName: "diagram-slider__PrevButton",
  componentId: "sc-f9wq63-1"
})(["cursor:pointer;", ";position:absolute;left:0;top:50%;transform:translateY(-50%);border-radius:0 5px 5px 0;fill:", ";box-shadow:0 4px 16px 0 ", ";"], function (props) {
  return props.disabled ? "display: none;" : "";
}, function (props) {
  return (0, _styles.colors)("icon-input", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.8, "background-dark")(props);
});

var Prev = function Prev(_ref2) {
  var disabled = _ref2.disabled,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement(PrevButton, {
    backgroundColor: "background",
    disabled: disabled,
    height: 80,
    onClick: onClick,
    width: 50
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    as: "span",
    height: 1,
    justifyContent: "center",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "span",
    display: "block",
    height: 32,
    width: 32
  }, /*#__PURE__*/_react["default"].createElement(_components.NavCaretLeft, null))));
};

Prev.propTypes = propTypesButton;
var SliderDot = (0, _styledComponents["default"])(function (_ref3) {
  var isActive = _ref3.isActive,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "diagram-slider__SliderDot",
  componentId: "sc-f9wq63-2"
})(["cursor:pointer;display:inline-block;border-radius:50%;border:1px solid ", ";", " &:last-child{margin:0;}"], function (props) {
  return (0, _styles.colors)("icon", props);
}, function (props) {
  return props.isActive ? "background-color: " + (0, _styles.colors)("icon", props) + ";" : "";
});
var PositionDotsContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "diagram-slider__PositionDotsContainer",
  componentId: "sc-f9wq63-3"
})(["position:absolute;left:0;"]);

var DotsContainer = function DotsContainer(props) {
  return /*#__PURE__*/_react["default"].createElement(PositionDotsContainer, _extends({
    alignItems: "center",
    justifyContent: "center",
    pt: 5,
    width: 1
  }, props));
};

var propTypesDot = {
  /** Boolean determines isActive */
  active: _propTypes.bool,

  /** onClick handler */
  onClick: _propTypes.func
};

var Dot = function Dot(_ref4) {
  var active = _ref4.active,
      onClick = _ref4.onClick;
  return /*#__PURE__*/_react["default"].createElement(SliderDot, {
    height: 14,
    isActive: active,
    mr: 1,
    onClick: onClick,
    width: 14
  });
};

Dot.propTypes = propTypesDot;
var propTypesControls = {
  children: _propTypes.node
};

var Controls = function Controls(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    height: 14,
    justifyContent: "center",
    pb: 2,
    pt: 3
  }, children);
};

Controls.propTypes = propTypesControls;
var settings = {
  customControls: Controls,
  customDots: Dot,
  customDotsContainer: DotsContainer,
  nextArrow: Next,
  prevArrow: Prev
};
var OverflowSlider = (0, _styledComponents["default"])(_slider["default"]).withConfig({
  displayName: "diagram-slider__OverflowSlider",
  componentId: "sc-f9wq63-4"
})(["position:static;overflow:visible;"]);
var propTypes = {
  children: _propTypes.node
};

var DiagramSlider = function DiagramSlider(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/_react["default"].createElement(OverflowSlider, settings, children);
};

DiagramSlider.propTypes = propTypes;
DiagramSlider.displayName = "Modules.DiagramSlider";
var _default = DiagramSlider;
exports["default"] = _default;